import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/app/lib/StoreProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MatomoAnalytics"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/components/Matomo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/components/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/components/ui/sonner.tsx");
